import { Direction } from "./types";
import {
  getKebabCase,
  getCapitalized,
  getStsListRepets,
  getStringGroupRepeats,
} from "./stringModifier";
import { getChangeStsList, getDec2StsList } from "./calculator";
/** Pattern display */

export const isWSRow = (
  direction: Direction,
  rowID: number,
  ws?: "even" | "odd"
) => {
  if (direction === "round") return false;
  return rowID % 2 === (ws === "even" ? 0 : 1);
};

export {
  getKebabCase,
  getCapitalized,
  getStsListRepets,
  getStringGroupRepeats,
  getChangeStsList,
  getDec2StsList,
};
